module.exports = {"320831100":"黎城镇","320831101":"金南镇","320831102":"闵桥镇","320831103":"塔集镇","320831106":"前锋镇","320831107":"吕良镇","320831108":"陈桥镇","320831109":"金北镇","320831110":"戴楼镇","320831111":"银涂镇","320831400":"宝应湖农场","320831401":"复兴圩农场","320831402":"粮棉原种场","320831403":"金湖经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320831.json
// module id = 832
// module chunks = 0